import { CivilLawSubjectType } from 'api/types/entity';
import { UpdateLegalClientRepresentativeParams } from 'api/types/params';
import { isFinanceProject, isGlobalProject } from 'config';
import {
  parseCompanyAddressParam,
  parseCompanyTaxResidencyParam,
  parseStateRegistrationParam,
  parseTaxResidencyParam,
  parsePepConnectionParam,
  parseCitizenshipsParam,
  parseBiographyParam,
  parseAdditionalInformationFileIdsParam,
  parseConstitutionalDocumentParam,
  parseAdditionalDocumentFileIdsParam,
  parseAddressWithFilesParam,
  parseDocumentsFileIdsParam,
} from 'modules/client/common/helpers';
import { parseIdentityDocumentWithFilesParam } from 'modules/client/common/helpers/parseParams/parseIdentityDocumentParam';

import { LegalRepresentativeFormType } from '../../forms/legalRepresentativeForm';

export const getLegalRepresentativeSubmitData = (
  versionNumber: number,
  values: LegalRepresentativeFormType
): UpdateLegalClientRepresentativeParams => {
  const isGlobal = isGlobalProject();
  const isFinance = isFinanceProject();

  const { placeOfBirth, registrationAddress, residentialAddress } =
    parseAddressWithFilesParam(values);

  const { Selfie } = parseDocumentsFileIdsParam(values.identityDocument.files);

  return {
    versionNumber,
    reason: values.reasonChange.reason,
    firstName: values.personalData.firstName,
    lastName: values.personalData.lastName,
    middleName: values.personalData.middleName ?? null,
    dateOfBirth: values.personalData.dateOfBirth,
    gender: values.personalData.gender?.value,
    biography: isFinance ? parseBiographyParam(values) : undefined,
    citizenships: parseCitizenshipsParam(values),

    registrationAddress: isFinance ? registrationAddress : undefined,
    residentialAddress,
    placeOfBirth,

    taxResidences: parseTaxResidencyParam(values, isGlobal),

    pepConnection: values.pepConnection.relation?.value!,
    connectedPepInfo: isFinance ? parsePepConnectionParam(values) : undefined,

    company:
      isFinance &&
      values.roleInCompany?.civilLawSubject?.value ===
        CivilLawSubjectType.JuridicalPerson
        ? {
            ...parseCompanyAddressParam({
              companyRegistrationAddress: values.companyRegistrationAddress!,
              companyResidentialAddress: values.companyResidentialAddress!,
            }),
            fullName: values.companyName!.fullName,
            shortName: values.companyName!.shortName,

            taxResidences: parseCompanyTaxResidencyParam({
              companyTaxResidences: values.companyTaxResidences!,
            }),
            stateRegistration: parseStateRegistrationParam({
              companyStateRegistration: values.companyStateRegistration!,
            }),
            constitutionalDocument: parseConstitutionalDocumentParam(
              values.constituentDocsFiles,
              values.constituentDocsDateOfLastChange
            ),
          }
        : undefined,

    roleInCompany: {
      roleInCompany: isGlobal ? values.roleInCompany.role?.value : undefined,
      authorityConfirmationDocument: {
        dateOfExpiration: values.roleInCompany.dateOfExpiration ?? undefined,
        dateOfIssue: values.roleInCompany.dateOfIssue,
        fileIds: values.roleInCompany.files.map(({ id }) => id!),
        number: values.roleInCompany.number,
      },
    },
    additionalInformationFileIds: parseAdditionalInformationFileIdsParam(
      values.additionalDocumentsFiles
    ),

    additionalDocumentFileIds: parseAdditionalDocumentFileIdsParam(
      values.documentsFiles
    ),

    identityDocument: parseIdentityDocumentWithFilesParam(values),

    selfieFileIds: Selfie?.map((file) => file.id!) ?? [],
  };
};
